// extracted by mini-css-extract-plugin
export default {"footerBg":"aa-z","footerTopLinks":"ba-z","footerFeedback":"ca-z","footerSocial":"da-z","footerLegalLinks":"ea-z","footerIconCards":"fa-z","footerBotCopy":"ga-z"};